import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useSearch } from "@/context/SearchContext";
import { ListDashes } from "@phosphor-icons/react";

const SEV_COLOR = { critical: "#FF3B30", high: "#FF9500", medium: "#FFCC00", low: "#00F0FF", info: "#71717A" };

export default function Events() {
  const [events, setEvents] = useState([]);
  const [sevFilter, setSevFilter] = useState("");
  const { query } = useSearch();

  const load = useCallback(async () => {
    const { data } = await api.get("/events");
    setEvents(data.events);
  }, []);
  useEffect(() => { load(); }, [load]);

  const q = query.trim().toLowerCase();
  const filtered = events.filter((e) => (!sevFilter || e.severity === sevFilter) && (!q || [e.message, e.type, e.actor].join(" ").toLowerCase().includes(q)));

  return (
    <div data-testid="events-page">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#00F0FF]">Activity Log</p>
          <h1 className="font-head text-3xl tracking-tighter font-black mt-1">Security Events</h1>
        </div>
        <div className="flex gap-1.5">
          {["", "critical", "high", "info"].map((s) => (
            <button key={s || "all"} data-testid={`event-filter-${s || "all"}`} onClick={() => setSevFilter(s)}
              className={`text-[10px] uppercase px-3 py-1.5 border ${sevFilter === s ? "border-[#00F0FF] text-[#00F0FF]" : "border-[#1F1F33] text-[#71717A]"}`}>{s || "all"}</button>
          ))}
        </div>
      </div>

      <div className="bg-[#0C0C14] border border-[#1F1F33]" data-testid="events-list">
        {filtered.map((e) => (
          <div key={e.id} data-testid={`event-${e.id}`} className="flex items-start gap-3 px-4 py-3 border-b border-[#1F1F33] border-l-2" style={{ borderLeftColor: SEV_COLOR[e.severity] }}>
            <ListDashes size={15} color={SEV_COLOR[e.severity]} className="mt-0.5 shrink-0" />
            <div className="min-w-0 flex-1">
              <div className="text-sm">{e.message}</div>
              <div className="text-[10px] text-[#71717A] mt-0.5 font-mono uppercase tracking-wider">{e.type} · {e.actor}</div>
            </div>
            <span className="text-[10px] text-[#71717A] shrink-0 tabular-nums">{new Date(e.timestamp).toLocaleTimeString()}</span>
          </div>
        ))}
        {filtered.length === 0 && <div className="text-xs text-[#71717A] py-10 text-center">No events match.</div>}
      </div>
    </div>
  );
}
